import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { isStaff } from '@utils/getRole';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const accountInfoDetailService = () => {
  const URL = isStaff
    ? ENDPOINTS.STAFF.ACCOUNT_INFO.READ
    : ENDPOINTS.ADMIN.ACCOUNT_INFO.READ;

  return axiosInstance
    .get(URL)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
